import React from 'react';
import SimplePage from '../../pages/SimplePage';

export default function LogsPage() {
  return <SimplePage title="Logs" subtitle="Audit trail and system logs." />;
}
